// extracted by mini-css-extract-plugin
export default {"Main":"NoBookFound_Main__fPpUH","Title":"NoBookFound_Title__5tHo0","SubTitle":"NoBookFound_SubTitle__wTrYy","Bunny":"NoBookFound_Bunny__xV6Kn"};